import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import GuestCalendar from '../components/GuestCalendar';
import './GuestCalendarPage.css';

const GuestCalendarPage = () => {
  const { userInfo } = useContext(UserContext);
  const guestUserId = userInfo?.user_id;
  const guestLevel = userInfo?.level;
  const guestProfileInfo = userInfo?.guest_profile;
  const guestInstagramId = userInfo?.instagram_id;
  const [guestProfile, setGuestProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 게스트 프로필 정보 가져오기
  useEffect(() => {
    const fetchGuestProfile = async () => {
      try {
        // 디버깅: userInfo 정보 출력 (개발 환경에서만)
        if (process.env.NODE_ENV === 'development') {
          console.log('=== 게스트 프로필 조회 디버깅 ===');
          console.log('userInfo:', guestUserId ? '[PRESENT]' : '[MISSING]');
          console.log('userInfo.guest_profile:', guestProfileInfo ? '[PRESENT]' : '[MISSING]');
          console.log('userInfo.user_id:', guestUserId);
        }

        // 게스트 아티스트인 경우 userInfo.guest_profile을 직접 사용
        if (guestLevel === 'guest_artist' && guestProfileInfo) {
          if (process.env.NODE_ENV === 'development') {
            console.log('게스트 아티스트입니다. userInfo.guest_profile을 사용합니다.');
            console.log('게스트 프로필 ID:', guestProfileInfo.id);
          }

          // userInfo.guest_profile을 직접 사용
          setGuestProfile(guestProfileInfo);
        } else if (guestLevel === 'guest_artist') {
          // 게스트 아티스트이지만 guest_profile이 없는 경우 기본값 사용
          if (process.env.NODE_ENV === 'development') {
            console.log('게스트 아티스트이지만 프로필 정보가 없습니다. 기본값을 사용합니다.');
          }
          const today = new Date();
          const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
          const endDate = new Date(today.getFullYear(), today.getMonth() + 3, 0);

          const mockGuestProfile = {
            guest_start_date: startDate.toISOString().split('T')[0],
            guest_end_date: endDate.toISOString().split('T')[0],
            is_active: true,
            instagram_id: guestInstagramId || null
          };
          setGuestProfile(mockGuestProfile);
        } else {
          throw new Error('게스트 아티스트가 아닙니다.');
        }
      } catch (err) {
        console.error('게스트 프로필 조회 실패:', err);
        setError('게스트 프로필을 불러올 수 없습니다.');
      } finally {
        setLoading(false);
      }
    };

    if (guestUserId) {
      fetchGuestProfile();
    }
  }, [guestInstagramId, guestLevel, guestProfileInfo, guestUserId]);

  // 노치 배경색 동기화 (PWA)
  useEffect(() => {
    const backgroundColor = '#fffdf8';
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta) {
      themeColorMeta.setAttribute('content', backgroundColor);
    }
    const originalBodyBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor = backgroundColor;

    return () => {
      if (themeColorMeta) {
        themeColorMeta.setAttribute('content', '#fffdf8');
      }
      document.body.style.backgroundColor = originalBodyBg;
    };
  }, []);

  if (loading) {
    return (
      <div className="guest-calendar-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>게스트 정보를 불러오는 중...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="guest-calendar-page">
        <div className="error-container">
          <h2>오류가 발생했습니다</h2>
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>다시 시도</button>
        </div>
      </div>
    );
  }

  return (
    <div className="guest-calendar-page">
      <GuestCalendar
        guestStartDate={guestProfile?.guest_start_date}
        guestEndDate={guestProfile?.guest_end_date}
      />
    </div>
  );
};

export default GuestCalendarPage;
